import React from 'react';
import { motion } from 'framer-motion';


const ScriptureOverlay = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: [0, 1, 1, 0] }}
    transition={{ duration: 12, repeat: Infinity }}
    className='overlay'
  >
    “For where two or three gather in my name, there am I with them.” — Matthew 18:20
  </motion.div>
);

export default ScriptureOverlay;




// import React from 'react';
// import { motion } from 'framer-motion';

// const ScriptureOverlay = () => {
//   return (
//     <motion.div 
//       initial={{ opacity: 0 }}
//       animate={{ opacity: [0, 1, 1, 0] }}
//       transition={{ duration: 12, repeat: Infinity }}
//       style={{
//         position: 'absolute',
//         top: '38%',
//         width: '100%',
//         textAlign: 'center',
//         color: '#fff',
//         fontStyle: 'italic',
//         fontSize: '1.5rem',
//         fontFamily: 'Georgia, serif',
//         textShadow: '0 0 10px rgba(255,255,255,0.6)',
//         zIndex: 2,
//         pointerEvents: 'none',
//       }}
//     >
//       “For where two or three gather in my name, there am I with them.” — Matthew 18:20
//     </motion.div>
//   );
// };

// export default ScriptureOverlay;
